<template lang="pug">
  .PublicPlayer(v-if="!error && video" :style="cssVars")
    Shape.public-background(:primary="video ? video.primaryColor : 'primary'")
    v-app-bar(color="transparent" flat )
      v-container
        a(href="https://simplymotion.de" target="_blank")
         v-img(:src="video.logoUrl" class="mr-2" max-height="40" max-width="200" contain v-if="video")
      
    v-container(fill-height)
      v-layout(justify-center align-center)
        v-row.mt-8
          v-col(cols="12" md="7" v-if="!error && video")
            v-row
              v-col(cols="12")
                .player()
                  video-player#videoPlayer.rounded-lg(
                    ref="videoPlayer",
                    :options="playerOptions",
                    @error="error = true",
                    :playsinline="true",
                    @ready="playerReadied",
                    
                  )
          v-col(cols="12" md="5" v-if=" !error &&video")
            v-card.rounded-lg.card.elevation-25(flat style="height: auto; position: relative;")
                  v-card-title.mr-8 {{ video.title }}
                  v-card-subtitle.caption {{ formatDate(video.createdAt) }}
                  v-card-text {{ video.description }}
  div(v-else-if="error")
    BlueShape.public-background
    v-container
      v-layout(justify-center align-center)
        v-row.mt-8
          v-col(cols="12")
            v-card.full-width.elevation-25.pt-2.rounded-lg
              v-card-title.justify-center
                | {{$t('publicPlayer.error')}} 
  .loading(v-else)
    BlueShape.public-background
    v-app-bar(flat color="transparent")
    v-container(fill-height)
      v-row.mt-8
          v-col(cols="12" md="7" )
            v-skeleton-loader.mx-auto.rounded-lg(type="image")
          v-col(cols="12" md="5")
            v-skeleton-loader.rounded-lg(class="mx-auto" width="100%" max-width="500" type="article") 
</template>

<script>
import { Api } from "@/services/api/index";
// import VueVideoPlayer from "vue-video-player";
import date from "@/utils/date";
import urlFormat from "@/utils/urlFormat";
import { VideoElement } from "@/models";
import Shape from "@/components/shared/Shape";
import BlueShape from "@/components/shared/BlueShape";

export default {
  name: "PublicPlayer",
  components: { Shape, BlueShape },
  data() {
    return {
      error: null,
      video: null,
      loading: true,
      playerOptions: {
        fluid: true,
        autoplay: false,
        loop: false,
        controls: true,
        language: "de",
        html5: {
          nativeAudioTracks: false,
          nativeVideoTracks: false,
          hls: {
            overrideNative: true,
          },
        },
        hls: {
          overrideNative: true,
        },
        sources: [
          {
            src: undefined,
            type: "application/x-mpegURL",
          },
        ],
      },
    };
  },
  computed: {
    cssVars() {
      if (this.video) {
        return {
          "--theme-primary-color": this.video.primaryColor,
          "--theme-accent-color": this.video.accentColor,
        };
      } else {
        return {
          "--theme-primary-color": this.$vuetify.theme.themes.light.primary,
          "--theme-accent-color": this.$vuetify.theme.themes.light.accent,
        };
      }
    },
  },
  methods: {
    ...date,
    ...urlFormat,
    playerReadied(player) {
      this.loading = false;
      const token = this.video.token;
      event(this.video.element.toLowerCase(), "play");
      if (!player.tech_.hls.xhr) return;
      player.tech_.hls.xhr.beforeRequest = function (options) {
        options.uri = `${options.uri}${token}`;
        return options;
      };
    },

    async fetchPublicVideoAsset() {
      const publicToken = this.$route.params?.publicToken;
      if (!publicToken) {
        this.error = "Invalid URL";
        return;
      }

      return Api()
        .VideoAssets()
        .getVideoAssetByPublicToken(publicToken)
        .then((response) => {
          if (response.data?.errors?.length > 0) {
            console.log("ERROR", response.data.errors);
            throw new Error(response.data.errors);
          }

          this.video = response.data.publicVideoAsset;
          const source = {
            src: this.getVideoDownloadUrl(
              this.video.id,
              this.video.token,
              "_16x9_1920x1080p_24Hz_6Mbps",
              "mp4",
              this.video.tID
            ),

            type: "video/mp4",
          };

          (this.playerOptions.poster = this.getThumbnailUrl(
            this.video.id,
            this.video.token,
            VideoElement.MOTION,
            this.video.tID
          )),
            (this.playerOptions.sources = [source]);
        })
        .catch((error) => {
          console.log("ERROR", { error });
          this.error = error.errors[0]?.message ?? error;
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetchPublicVideoAsset();
  },
};
</script>

<style lang="sass">
@import "@/assets/style/main"
.PublicPlayer
  .video-js
    .vjs-big-play-button
      background-color: var(--theme-primary-color) !important
      &:hover
        background-color: var(--theme-accent-color) !important
    .vjs-play-progress, .vjs-volume-level
      background-color: var(--theme-accent-color) !important
    .vjs-loading-spinner
      border-color: var(--theme-accent-color) !important
.public-background
  position: fixed
  padding: 0
  top: 0
  left: 0
  height: 50vh
@media only screen and (max-width: 600px)
  .public-background
    position: absolute !important
</style>
